<template>
  <v-bottom-sheet inset v-model="showToast" @input="onClose">
    <v-card tile>
      <v-alert
        outline
        class="ma-0"
        color="warning"
        type="warning"
        :value="showToast"
      >
        <div v-if="title" class="title mb-1">
          {{ title }}
        </div>

        <div>{{ mensagem }}</div>
      </v-alert>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "ErrorToast",
  props: {
    error: String,
    showToast: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showToast() {
      this.visible = this.showToast;

      if (this.showToast) {
        this.tratarErro();
      }
    },
    visible: {
      handler() {
        if (!this.visible) {
          this.onClose();
        }
      }
    }
  },
  data() {
    return {
      mensagem: null,
      title: null,
      visible: false
    };
  },
  methods: {
    ...mapMutations(["clearErrorToast"]),
    onClose() {
      this.clearErrorToast();
    },
    tratarErro() {
      const data = this.error.split("|");
      if (data.length === 1) {
        this.title = "";
        this.mensagem = this.error;
        return;
      }
      const titleFail = `Falha na integração (${data[0]} ${data[2]})`;
      const titleInfo = `Sistema de gestão informou (${data[0]})`;

      this.title = data[2] ? titleFail : titleInfo;
      this.mensagem = data[1];
    }
  }
};
</script>
